import Vue         from "vue";
import Router      from "vue-router";
import AppFooter   from "./layout/AppFooter.vue";
import AppNavbar   from "./layout/AppNavbar.vue";
// import AppNavbar from "./layout/AppNavbar.vue";
import MainFooter  from "./layout/MainFooter.vue";
import MainNavbar  from "./layout/MainNavbar.vue";
import ContactUs   from "./pages/app/ContactUs.vue";
import AppHelpPage from "./pages/app/HelpPage.vue";

import MainPage        from "./pages/app/MainPage.vue";
import MealsPage       from "./pages/app/MealsPage.vue";
import HistoryPage     from "./pages/app/HistoryPage.vue";
import AppPaymentsPage from "./pages/app/PaymentsPage.vue";
import ProfilePage     from "./pages/app/ProfilePage.vue";
import Presentation    from "./pages/Presentation.vue";
import AboutUs         from "./pages/public/AboutUs.vue";
import Help            from "./pages/public/Help.vue";
import License         from "./pages/public/License.vue";
import Privacy         from "./pages/public/Privacy.vue";

import LoginPage  from "./pages/public/LoginPage.vue";
import SignUpPage from "./pages/public/SignUpPage.vue";
import ForgotPasswordPage from "./pages/public/ForgotPasswordPage.vue";

Vue.use(Router);

let routeConfig = {
  
  mode          : "history",
  routes        : [
    {
      path      : "/login",
      name      : "login",
      components: {default: LoginPage, header: MainNavbar},
      props     : {header: {colorOnScroll: 60}}
    },
    {
      path      : "/signup",
      name      : "signup",
      components: {default: SignUpPage, header: MainNavbar},
      props     : {header: {colorOnScroll: 60}}
    },
    {
      path      : "/forgotpassword",
      name      : "forgotpassword",
      components: {default: ForgotPasswordPage, header: MainNavbar},
      props     : {header: {colorOnScroll: 50}}
    },
    {
      path      : "/",
      name      : "presentation",
      components: {default: Presentation, header: MainNavbar, footer: MainFooter},
      props     : {header: {colorOnScroll: 50}}
    },
    {
      path      : "/about",
      name      : "about",
      components: {default: AboutUs, header: MainNavbar, footer: MainFooter},
      props     : {header: {colorOnScroll: 50}}
    },
    {
      path      : "/help",
      name      : "help",
      components: {default: Help, header: MainNavbar, footer: MainFooter},
      props     : {header: {colorOnScroll: 60}}
    },
    {
      path      : "/license",
      name      : "license",
      components: {default: License, header: MainNavbar, footer: MainFooter},
      props     : {header: {colorOnScroll: 60}}
    },
    {
      path      : "/privacy",
      name      : "privacy",
      components: {default: Privacy, header: MainNavbar, footer: MainFooter},
      props     : {header: {colorOnScroll: 60}}
    },
    {
      path      : "/contact",
      name      : "contact",
      components: {default: ContactUs, header: MainNavbar, footer: MainFooter},
      props     : {footer: {type: 'default'}}
    },
    
    {
      path      : "/app/main",
      name      : "main",
      meta      : {requiresAuth: true},
      components: {default: MainPage, header: AppNavbar, footer: AppFooter},
      props     : {footer: {backgroundColor: 'gray'}, header: {colorOnScroll: 58}}
    },
    {
      path      : "/app/profile",
      name      : "appProfile",
      meta      : {requiresAuth: true},
      components: {default: ProfilePage, header: AppNavbar, footer: AppFooter},
      props     : {header: {colorOnScroll: 58}}
    },
    {
      path      : "/app/meals",
      name      : "appMeals",
      meta      : {requiresAuth: true},
      components: {default: MealsPage, header: AppNavbar, footer: AppFooter},
      props     : {header: {colorOnScroll: 53}}
    },
    {
      path      : "/app/history",
      name      : "appHistory",
      meta      : {requiresAuth: true},
      components: {default: HistoryPage, header: AppNavbar, footer: AppFooter},
      props     : {header: {colorOnScroll: 53}}
    },
    {
      path      : "/app/payments",
      name      : "appPayments",
      meta      : {requiresAuth: true},
      components: {default: AppPaymentsPage, header: AppNavbar, footer: AppFooter},
      props     : {header: {colorOnScroll: 450}}
    },
    {
      path      : "/app/help",
      name      : "appHelp",
      meta      : {requiresAuth: true},
      components: {default: AppHelpPage, header: AppNavbar, footer: AppFooter},
      props     : {header: {colorOnScroll: 58}}
    }
  
  ],
  scrollBehavior: (to, from, savedPosition) => {
    if(to.hash) {
      return {selector: to.hash}
    } else {
      return {x: 0, y: 0}
    }
  },
};

const router = new Router(routeConfig);
router.beforeEach((to, from, next) => {
  try {
    if (to.meta && to.meta.requiresAuth === true) {
      const app = router.app;
      const authenticated = app && app.isAuthenticated === true;
      if (!authenticated) {
        return next({ path: "/login" });
      }
    }
  } catch (err) {
    console.log("oops, caught no meta.requiresAuth", err.message);
  }
  next();
});

export default router;
